import {SimpleListActions} from 'mc/lib/list';
import {Api} from '../api';

const AREA = 'typZaborList';

export function fetchIfNeeded(force = false) {
    return SimpleListActions.fetchIfNeeded(AREA, null, (parent, filter) => Api.getTypZaborList(filter.text), force);
}

export function filter(text) {
    return SimpleListActions.filter(AREA, {text});
}
